

import React, { memo } from 'react';
import cx from 'classnames';
import '../styles/_password-strength.scss';

const STRENGTH_MAP = ['Weak', 'Fair', 'Good', 'Strong', 'Strong'];







function renderFeedback(password, strength, invalid) {
  if (!password) {
    return null;
  }

  if (invalid) {
    return <p>Password does not meet requirements.</p>;
  }

  return (
    <p>
      Password strength:
      {' '}
      <b>{strength}</b>
    </p>);

}

function PasswordStrength({ password, score, invalid }) {
  const strength = STRENGTH_MAP[score];

  return (
    <div className={cx('password-strength', { invalid })}>
      <div className="password-strength__outer">
        <div
          className={cx(
            'password-strength__inner',
            { [`password-strength__inner--${strength.toLowerCase()}`]: password }
          )} />

      </div>
      {renderFeedback(password, strength, invalid)}
    </div>);

}

export default memo(PasswordStrength);